/**
 * GTM order_payment_type values (match SFCC case values).
 * Used for the order_payment_type field in page interaction data.
 */
export enum GTMPaymentType {
  CreditCard = 'CREDIT_CARD',
  ApplePay = 'DW_APPLE_PAY',
  Afterpay = 'AFTERPAY_PBI',
  PayPal = 'PayPal',
  GiftCard = 'GIFT_CERTIFICATE',
  None = 'NONE',
  Unknown = 'UNKNOWN'
}
